'use strict';

module.exports = (app) => app.factory('parkedInvoiceService', /* @ngInject */ function (httpService, apiConfig, FileSaver) {

	function findByOrderId(orderId) {
		const uri = apiConfig.getBase('invoice', 'parked');
		uri.query.orderId = orderId;
		return httpService.get(uri.toString(), {
			isArray: true
		})
	}

	function downloadFile(parkedInvoiceId) {
		const uri = apiConfig.getBase('invoice', 'parked', 'file', parkedInvoiceId);

		return httpService.get(uri.toString(), {
			isArray: false,
			responseType: 'arraybuffer',
			transformResponse: (data, headers) => {
				const contentType = headers('Content-Type');
				const contentDisposition = parseContentDispositionFilename(headers('Content-Disposition'));
				const blob = new Blob([new Uint8Array(data)], {
					type: contentType
				});
				FileSaver.saveAs(blob, contentDisposition ?? 'prebooked_invoice_attachment');
			}
		})
	}

	/**
	 * Extracts the filename out of response headers.
	 * The filename must be included in the filename property of the Content-Disposition HttpHeader
	 * @param contentDisposition - the content-disposition header content
	 * @return filename as string or empty string if the filename cannot be found
	 */
	function parseContentDispositionFilename(contentDisposition) {
		if (contentDisposition && contentDisposition.includes('filename')) {
			const filenameRegex = new RegExp(`filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?`);
			const res = filenameRegex.exec(contentDisposition);

			return res ? res[1] : '';
		}

		return '';
	}

	return {
		/**
		 * @return {(orderId: string) => any}
		 */
		findByOrderId,
		downloadFile
	}

});
